import "./ButtonSecondary.css";

const ButtonSecondary = ({ text, onClick, fontWeight=700, fontSize='16px', disabled=false, loading=false }) => {
  return (
    <button
      className={`buttonSecundary ${disabled ? 'disabled' : ''} ${loading ? 'loading' : ''}`}
      style={{ fontWeight: fontWeight, fontSize: fontSize }}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? 'Carregando...' : text}
    </button>
  );
}

export default ButtonSecondary;
